// AudioPlayer.js
import React from "react";
import { HStack, Image } from "@chakra-ui/react";
import { useAudio } from "../../../context/AudioContext";
import Mute from "../../../assets/ai-tutor/audio-mute.svg";
import LoadingAnimation from "../../../assets/ai-tutor/spectrumgrey.json";
import Lottie from "react-lottie-player";
import DarkAnimation from "../../../assets/ai-tutor/darkAnimation.json";
import LightAnimation from "../../../assets/ai-tutor/lightAnimation.json";
import AudioAnimation from "../../../assets/ai-tutor/SpectrumBlack.json"


const AudioPlayer = ({ text, index, chatID, chatIndex, isCorrect, questionId }) => {
  const { playingIndex, audioLoader, handlePlayPause } = useAudio();

  const handleClick = () => {
    handlePlayPause(index, text, chatID, chatIndex, isCorrect, questionId);
  };

  const isLoading = audioLoader && playingIndex === index;
  const isCurrentPlaying = playingIndex === index;
  // console.log("is Loading----" + isLoading);
  // console.log("Chat Index----" + index);
  // console.log("Playing Index----" + playingIndex);

  return (
    <div style={{ display: "flex", alignItems: "flex-start", marginLeft: '24px', width: "60px" }}>
      {isLoading &&
        <Lottie
          loop
          animationData={LoadingAnimation}
          play
          style={{ width: "36px", height: "36px" }}
        />
      }
      {!isLoading && !isCurrentPlaying && (
        <div style={{ display: "flex", alignItems: "center", flexShrink: 0, minWidth: "40px" }}>
          <Image
            src={Mute}
            onClick={handleClick}
            cursor="pointer"
            width="36px"
            height="36px"
          />
        </div>

      )}
      {!isLoading && isCurrentPlaying && (
        <HStack spacing={0} onClick={handleClick} cursor="pointer">
          {/* <Lottie
            loop
            animationData={DarkAnimation}
            play
            style={{ width: "30px", height: "36px" }}
          />
          <Lottie
            loop
            animationData={LightAnimation}
            play
            style={{ width: "30px", height: "36px", marginLeft: "-2px" }}
          /> */}
          <Lottie
            loop
            animationData={AudioAnimation}
            play
            style={{ width: "36px", height: "36px" }}
          />
        </HStack>

      )}
    </div>
  );
};

export default AudioPlayer;
